module.exports = __webpack_public_path__ + "static/media/logo-white.f2023b49.png";